<script lang="ts">
	import { _ } from 'svelte-i18n';
	import { createForm } from 'felte';

	import { getHubStores } from '$lib/stores/hubStores';
	import { onDestroy } from 'svelte';
	import { toastMessages } from '$lib/stores/toastMessageStore';
	import ButtonLink from '$lib/components/ButtonLink/ButtonLink.svelte';
	import CheckBox from '$lib/components/Inputs/CheckBox.svelte';
	const { hub, restApi } = getHubStores();

	export let setSettingsNotActive: () => void;
	export let close: () => void;

	let isSubscribedToNewsletter: boolean;
	let isNotifiedOfPostActivities: boolean;

	const getSettings = async () => {
		const [respNewsLetter, respActivity] = await Promise.all([
			restApi.fetchNewsLetterSettings($hub.id),
			restApi.fetchActivitySettings($hub.id),
		]);
		if (respNewsLetter.error || respActivity.error) {
			toastMessages.danger($_('hub.user.profileVariable.load.error'), '');
		} else {
			isSubscribedToNewsletter = respNewsLetter.data?.status === 'subscribed';
			isNotifiedOfPostActivities = respActivity.data?.status === 'subscribed';
		}
	};

	onDestroy(setSettingsNotActive);

	type FormTypes = {
		isNotifiedOfPostActivities: boolean;
		isSubscribedToNewsletter: boolean;
	};

	const { form } = createForm<FormTypes>({
		async onSubmit(values) {
			let res1 = await restApi.updateActivitySettings($hub.id, values.isNotifiedOfPostActivities);
			let res2 = await restApi.updateNewsletterSettings($hub.id, values.isSubscribedToNewsletter);
			if (res1.error) {
				toastMessages.danger($_('hubs.settings.failed.to.save.changes'), res1.error);
			}
			if (res2.error) {
				toastMessages.danger($_('hubs.settings.failed.to.save.changes'), res2.error);
			}
			close();
		},
	});
</script>

<div class="container">
	<div class="innerWrapper">
		{$_('notification.settings.header')}
	</div>
	{#await getSettings() then}
		<form use:form>
			<div class="innerWrapper">
				<CheckBox
					name="isSubscribedToNewsletter"
					bind:checked={isSubscribedToNewsletter}
					placeholder={$_('notification.settings.receive.community')} />
			</div>
			<div class="innerWrapper">
				<CheckBox
					name="isNotifiedOfPostActivities"
					bind:checked={isNotifiedOfPostActivities}
					placeholder={$_('notifications.settings.receive.posts')} />
			</div>
			<div class="links">
				<ButtonLink on:click={setSettingsNotActive}>{$_('common.back')}</ButtonLink>
				<div class="saveClose">
					<ButtonLink on:click={close}>{$_('common.cancel')}</ButtonLink>
					<ButtonLink type="submit">{$_('common.save')}</ButtonLink>
				</div>
			</div>
		</form>
	{/await}
</div>

<style>
	.container {
		inline-size: 300px;
		padding-inline: var(--gutterMedium);
	}

	@media only screen and (max-width: 500px) {
		.container {
			inline-size: 70vw;
		}
	}

	.innerWrapper {
		padding-block: var(--gutterMedium);
		border-block-end: solid 1px var(--grayLighter);
	}

	.links {
		display: flex;
		justify-content: space-between;
		padding-block: var(--gutterMedium);
	}

	:global(.links > button),
	:global(.links > * > button) {
		color: inherit;
	}

	.saveClose {
		display: flex;
		gap: var(--gutterLarge);
	}
</style>
